import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { individualsService, InviteIndividualsRequest } from '@aslanpay/portal-common-lib';

const useInviteIndividuals = ({
  onSuccess,
  onError,
}: UseMutationOptions<unknown, Error, InviteIndividualsRequest>) => {
  return useMutation<unknown, Error, InviteIndividualsRequest>(
    ({ ids }: InviteIndividualsRequest) => individualsService.inviteIndividuals(ids),
    { onSuccess, onError }
  );
};

export default useInviteIndividuals;
